'use client';

import { c as _c } from "react/compiler-runtime";
import { type Address, type ChainId, ChainUtils } from '@morpho-org/blue-sdk';
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { ClipboardButton, DataList, InfoTooltip } from '@morpho-org/ui-v6/client';
import { Tag } from '@morpho-org/ui-v6/server';
import { isZeroAddressOrUnset } from '@morpho-org/ui-v6/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { ArrowDiagonalUp } from '@repo/ui/icons';
import { memo, useMemo } from 'react';
import { ButtonLink } from '@/components/common/ButtonLink';
import AddressDataLineLabel from '@/components/common/DataLine/AddressDataLine/AddressDataLineLabel';
export interface AddressDataLineProps {
  title: string;
  chainId: ChainId;
  address?: Address;
  labelTag?: string;
  tooltipMessage?: string;
  toastMessage?: string;
  safeQuorum?: string;
  isAragonDAO?: boolean;
  roleTooltip?: string;
}
const AddressDataLine = t0 => {
  const $ = _c(33);
  const {
    title,
    chainId,
    address,
    labelTag,
    tooltipMessage,
    toastMessage,
    safeQuorum,
    isAragonDAO,
    roleTooltip
  } = t0;
  let t1;
  if ($[0] !== address) {
    t1 = isZeroAddressOrUnset(address);
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMissingAddress = t1;
  let t2;
  if ($[2] !== address || $[3] !== chainId) {
    t2 = address ? ChainUtils.getExplorerAddressUrl(chainId, address) : null;
    $[2] = address;
    $[3] = chainId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const addressLink = t2;
  let t3;
  if ($[5] !== title) {
    t3 = <span className="text-secondary-foreground text-xs">{title}</span>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== roleTooltip) {
    t4 = roleTooltip && <InfoTooltip tooltipContent={roleTooltip} />;
    $[7] = roleTooltip;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== labelTag) {
    t5 = labelTag && <Tag variant="main" label={labelTag} />;
    $[9] = labelTag;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <DataList.LeftItem><div className="flex items-center gap-[6px]">{t3}{t4}{t5}</div></DataList.LeftItem>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== address || $[16] !== isAragonDAO || $[17] !== isMissingAddress || $[18] !== safeQuorum) {
    t7 = <AddressDataLineLabel address={address} isMissingAddress={isMissingAddress} safeQuorum={safeQuorum} isAragonDAO={isAragonDAO} textClassName="text-xs" />;
    $[15] = address;
    $[16] = isAragonDAO;
    $[17] = isMissingAddress;
    $[18] = safeQuorum;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== address || $[21] !== addressLink || $[22] !== chainId || $[23] !== isMissingAddress || $[24] !== toastMessage || $[25] !== tooltipMessage) {
    t8 = !isMissingAddress && <div className="flex items-center"><ClipboardButton toCopy={address} toastMessage={toastMessage || "Address copied to clipboard."} tooltipMessage={tooltipMessage} /><Tooltip><TooltipTrigger asChild={true}><div className="flex"><ButtonLink href={addressLink} buttonProps={{
              variant: "ghost",
              size: "sm",
              iconRight: undefined,
              iconAlone: <ArrowDiagonalUp />,
              iconAloneProps: {
                className: "text-secondary-foreground"
              }
            }} /></div></TooltipTrigger><TooltipContent>{`Go to ${InterfaceChainUtils.tryGetChain(chainId)?.blockExplorers?.default.name || "block explorer"}.`}</TooltipContent></Tooltip></div>;
    $[20] = address;
    $[21] = addressLink;
    $[22] = chainId;
    $[23] = isMissingAddress;
    $[24] = toastMessage;
    $[25] = tooltipMessage;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t7 || $[28] !== t8) {
    t9 = <DataList.RightItem><div className="gap-2xs flex items-center">{t7}{t8}</div></DataList.RightItem>;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t6 || $[31] !== t9) {
    t10 = <DataList.Line>{t6}{t9}</DataList.Line>;
    $[30] = t6;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
};
export default memo(AddressDataLine);